waitForElementToExist('#newsletter').then(element => {

    $('#js-form-news').submit(function (event) {
        event.preventDefault();

        $('#js-form-news').addClass('form-news-sending')

        var data = {
            'email': $(this).find('#email').val()
        }

        var action = newsLetter.addEmail(data);
    });

    $('#js-form-news-2').submit(function (event) {
        event.preventDefault();

        $('#js-form-news-2').addClass('form-news-sending')

        var data = {
            'email': $(this).find('#email_2').val()
        }

        var action = newsLetter.addEmail(data);
    });

    var newsLetter = new NewsLetter();
    var newsLetterBox = $('.modal-newsletter');
    var newsLetterMessage = $('.newsletter__content--message');
    var newsForm = $('.newsletter__form');

    $(newsLetter).bind('onSuccessAddEmailNewsLetter', function (event, data) {
        event.preventDefault();
        newsLetterBox.addClass('is-active');
        newsLetterMessage.html('OBRIGADO POR PARTICIPAR, CONFIRA SEU E-MAIL!').addClass('success');

        // $('#email').val('').attr('placeholder', 'Email enviado com sucesso').addClass('is-success');
        setTimeout(function () {
            newsLetterBox.removeClass('is-active');
            newsLetterMessage.removeClass('success');
            // $('#email').attr('placeholder', 'Email').removeClass('is-success')

            newsForm.removeClass('form-news-sending')

        }, 4000);
    }).bind('onFailAddEmailNewsLetter500', function (event, data, jqXHR, textStatus, errorThrown) {
        newsLetterBox.addClass('is-active');
        newsLetterMessage.html('<i class="icon-svg-error-close icon-close"></i> O email já está cadastrado!').addClass('error');
        // $('#email').val('').attr('placeholder', 'O email já está cadastrado!').addClass('error');
        setTimeout(function () {
            newsLetterBox.removeClass('is-active');
            newsLetterMessage.removeClass('error');

            // $('#email').attr('placeholder', 'Email').removeClass('is-error');
            newsForm.removeClass('form-news-sending')

        }, 4000);
        newsLetterBox.addClass('is-active');
        newsLetterMessage.html(data.email[0]).addClass('error');
    }).bind('onFailAddEmailNewsLetter', function (event, data, jqXHR, textStatus, errorThrown) {
        event.preventDefault();
        console.log('Error: ', data);
        newsLetterBox.addClass('is-active');
        newsLetterMessage.html('Endereço de e-mail já está cadastrado').addClass('error');
        // $('#email').val('').attr('placeholder', data.email[0]).addClass('is-error');
        setTimeout(function () {
            newsForm.removeClass('form-news-sending')

            newsLetterBox.removeClass('is-active');
            setTimeout(function () { newsLetterMessage.removeClass('error') }, 1220);

            $('#email').attr('placeholder', 'Email').removeClass('is-error');

        }, 4000);
    }).bind('onAlwaysAddEmailNewsLetter', function (event, data_or_jqXHR, textStatus, jqXHR_or_errorThrown) {


    });
});

waitForElementToExist('.new-newsletter').then(element => {
    const firstForm = document.querySelector('.first-form');
    const buttonAdvance = document.querySelector('.advance');
    const secondForm = document.querySelector('.second-form');
    const backForm = document.querySelector('#back-form');
    const nomeInput = document.querySelector('.first-form #adult-name');
    const emailInput = document.querySelector('.first-form #email');

    function validateInputs() {
        const isNomeFilled = nomeInput && nomeInput.value.trim() !== '';
        const isEmailFilled = emailInput && emailInput.value.trim() !== '';
        buttonAdvance.disabled = !(isNomeFilled && isEmailFilled);

        if (isNomeFilled && isEmailFilled) { 
            buttonAdvance.classList.remove('disabled');
        } else {
            buttonAdvance.classList.add('disabled');
        }
    }

    if (nomeInput && emailInput) {
        nomeInput.addEventListener('input', validateInputs);
        emailInput.addEventListener('input', validateInputs);
        validateInputs();
    }

    if (firstForm && buttonAdvance && secondForm && backForm) {
        buttonAdvance.addEventListener('click', (e) => {
            e.preventDefault();
            if (!buttonAdvance.disabled) {
                firstForm.classList.toggle('active');
                secondForm.classList.toggle('active');
                backForm.classList.toggle('active');
            }
        });

        backForm.addEventListener('click', (e) => {
            e.preventDefault();
            firstForm.classList.toggle('active');
            secondForm.classList.toggle('active');
            backForm.classList.toggle('active');
        });
    }

    var newNewslleter = new NewsLetter();

    $('.first-form').submit(function (event) {
        event.preventDefault();

        var data = {
            'email': $(this).closest('.new-newsletter-content').find('.first-form #email').val(),
            'nome': $(this).closest('.new-newsletter-content').find('.first-form #adult-name').val(),
            'properties': {
                'nomefilho': $(this).find('#son-name').val(),
                'idade': $(this).find('#age').val(),
            }
        }

        var action = newNewslleter.addEmail(data);
    });

    var newsLetterBox = $('.new-newsletter-modal');

    $(newNewslleter).bind('onSuccessAddEmailNewsLetter', function (event, data) {
        event.preventDefault();
        newsLetterBox.addClass('active');
        newsLetterBox.html('Obrigado Por Participar, Confira Seu E-mail!').addClass('success');

        setTimeout(function () {
            newsLetterBox.removeClass('active');
            newsLetterBox.removeClass('success');
        }, 4000);
    }).bind('onFailAddEmailNewsLetter500', function (event, data, jqXHR, textStatus, errorThrown) {
        newsLetterBox.addClass('active');
        newsLetterBox.html('O email já está cadastrado!').addClass('error');

        setTimeout(function () {
            newsLetterBox.removeClass('active');
            newsLetterBox.removeClass('error');
        }, 4000);

        newsLetterBox.addClass('is-active');
        newsLetterBox.html(data.email[0]).addClass('error');
    }).bind('onFailAddEmailNewsLetter', function (event, data, jqXHR, textStatus, errorThrown) {
        event.preventDefault();
        console.log('Error: ', data);
        newsLetterBox.addClass('active');
        newsLetterBox.html('Endereço de e-mail já está cadastrado').addClass('error');

        setTimeout(function () {
            newsLetterBox.removeClass('active');
            setTimeout(function () { newsLetterBox.removeClass('error') }, 1220);

            $('#email').attr('placeholder', 'Email').removeClass('is-error');
        }, 4000);
    });
});

